<template>
  <div class="appBody bg-white" v-if="!loading && sessionExam">
    <exam-index :sessionExam="sessionExam" :stat="status" v-if="status === 'no'"></exam-index>
    <exam-text v-else-if="status === 'going'" :userExId=userExamId :durationFromSession="sessionExam.duration">
      {{userExamId}}
    </exam-text>
    <exam-result :examResult="sessionExam" v-else :userExamId=userExamId></exam-result>
  </div>
</template>

<script>
  import ExamIndex from './examIndex';
  import ExamText from './examText';
  import ExamResult from './examResult';
  import {mapState} from "vuex";

  export default {
    name: "examSession",
    components: {ExamResult, ExamText, ExamIndex},
    data() {
      return {
        userExamModel: {},
        sessionExam: {},
        sessionId: '',
        userExamId: '',
        status: '',
        serverCurrentTime: 0,
        isSubmitted: false,
        finished: true,
        loading: false,
      }
    },
    props: ['reExam', 'sessionReExam'],
    created() {
      if (this.reExam) {
        this.status = 'no';
      }
      if (this.sessionReExam) {
        this.sessionExam = this.sessionReExam;
        if(this.sessionExam.duration > 0) {
          //如果计时就获取服务器端当前时间
          this.getServerCurrentTime();
        }
      }

    },
    computed: {
      ...mapState({
        recordStudyTip: state => state.recordStudy
      })
    },
    mounted() {
      this.sessionId = this.$route.params['id'];
      if (!this.sessionExam || !this.sessionExam.id) {
        this.getSessionExamForLearner();
      }

    },
    methods: {
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.sessionExam;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
      getSessionExamForLearner() {
        this.loading = true;
        this.$store.dispatch('getSessionExamForLearnerUrl', {id: this.sessionId}).then((res) => {
          this.sessionExam = res;
          if(res && !res.recordStudy) {
            this.$toast(this.recordStudyTip);
          }
          if(res && res.duration>0) {
            //如果计时就获取服务器端当前时间
            this.getServerCurrentTime();
          }
          if (res && res.userSession) {
            if (res.userSession.userExams && res.userSession.userExams.length > 0) {
              for (let model of res.userSession.userExams) {
                if (model.finished) {
                  this.isSubmitted = true;
                }
                this.finished = model.finished;

                if(!this.finished) {
                  //考试时间不限制
                  if(res.duration<=0) {
                    this.status = "going";
                    this.userExamId = model.id;
                    break;
                  } else {
                    //没有完成继续开始，并且结束时间晚于当前时间 还能继续考试
                    if (model.finishedTime &&
                      model.createdTime &&
                      this.serverCurrentTime &&
                      (model.finishedTime > this.serverCurrentTime ||
                        model.finishedTime === model.createdTime)) {
                      this.status = "going";
                      this.userExamId = model.id;
                      break;
                    } else if (model.finishedTime &&
                      this.serverCurrentTime &&
                      this.serverCurrentTime > model.finishedTime) {
                      this.finished = this.isSubmitted;
                    }
                  }
                }
              }
              if (this.finished) {
                this.status = "finished";
              }
            } else {
              this.status = "no";
            }
          } else {
            this.status = "no";
          }
          this.loading = false;
        })

      },
      getServerCurrentTime() {
        this.$store.dispatch('getServerCurrentTimeUrl', {}).then((time) => {
          this.serverCurrentTime = parseInt(time.data);
        })
      },
    }
  }
</script>

<style scoped>

</style>
